// Generated by tools/build/i18n_bundle.py — do not edit by hand.
// Fetch the per-locale message bundle. Deferred and first of the app's own
// scripts, so nothing blocks the parser for it; js/i18n.js swaps the table
// in when the bundle lands and js/app.js holds the first paint for
// window.__GHD_BUNDLE_READY__. No page script calls t() as it evaluates.
// Locale resolution must match js/i18n.js.
(function () {
  var SHIPPED = ["en", "nl", "de", "es", "fr", "pt", "it", "hu", "ru", "pl", "id", "tr", "ca", "uk", "el", "cs", "sv", "nb", "ro", "fi", "th", "vi", "bg", "da", "ja", "ko", "zh"];
  function pick(code) {
    if (!code) return null;
    var primary = String(code).replace("_", "-").split("-")[0].toLowerCase();
    return SHIPPED.indexOf(primary) !== -1 ? primary : null;
  }
  // Set by i18n/arrival-locale.js from the ?lang= a localized marketing
  // page named on the link over here. Ahead of storage because on a device
  // that has none it is the only thing carrying the visitor's language.
  var arrival = typeof window !== "undefined" ? window.__GHD_ARRIVAL_LANG__ : null;
  var stored = null;
  var signedOutAuth = null;
  try {
    stored = localStorage.getItem("ghd_ui_lang");
    signedOutAuth = sessionStorage.getItem("ghd_signed_out_auth_locale");
  } catch (e) {}
  var lang =
    pick(arrival) ||
    pick(stored) ||
    pick(signedOutAuth) ||
    pick(typeof navigator !== "undefined" ? navigator.language : null) ||
    "en";
  // The registry the runtime clamps codes against. The bundle carries it
  // too; publishing it here lets js/i18n.js resolve the same locale before
  // the bundle lands.
  window.__GHD_LOCALES__ = window.__GHD_LOCALES__ || [{"code": "en", "native": "English", "english": "English"}, {"code": "nl", "native": "Nederlands", "english": "Dutch"}, {"code": "de", "native": "Deutsch", "english": "German"}, {"code": "es", "native": "Español", "english": "Spanish"}, {"code": "fr", "native": "Français", "english": "French"}, {"code": "pt", "native": "Português", "english": "Portuguese"}, {"code": "it", "native": "Italiano", "english": "Italian"}, {"code": "hu", "native": "Magyar", "english": "Hungarian"}, {"code": "ru", "native": "Русский", "english": "Russian"}, {"code": "pl", "native": "Polski", "english": "Polish"}, {"code": "id", "native": "Bahasa Indonesia", "english": "Indonesian"}, {"code": "tr", "native": "Türkçe", "english": "Turkish"}, {"code": "ca", "native": "Català", "english": "Catalan"}, {"code": "uk", "native": "Українська", "english": "Ukrainian"}, {"code": "el", "native": "Ελληνικά", "english": "Greek"}, {"code": "cs", "native": "Čeština", "english": "Czech"}, {"code": "sv", "native": "Svenska", "english": "Swedish"}, {"code": "nb", "native": "Norsk", "english": "Norwegian"}, {"code": "ro", "native": "Română", "english": "Romanian"}, {"code": "fi", "native": "Suomi", "english": "Finnish"}, {"code": "th", "native": "ไทย", "english": "Thai"}, {"code": "vi", "native": "Tiếng Việt", "english": "Vietnamese"}, {"code": "bg", "native": "Български", "english": "Bulgarian"}, {"code": "da", "native": "Dansk", "english": "Danish"}, {"code": "ja", "native": "日本語", "english": "Japanese"}, {"code": "ko", "native": "한국어", "english": "Korean"}, {"code": "zh", "native": "繁體中文", "english": "Traditional Chinese", "bcp47": "zh-Hant"}];
  // The bundle sits next to this loader, so resolve it against the loader's
  // own URL: then any document in the tree can load the loader from its own
  // path (the app shell at its base, the OAuth consent page two levels down)
  // and the bundle is still fetched from the loader's directory — which, on
  // a built page, is this release's /v/<release>/i18n/ copy (the pages and
  // the service worker name the same URL, so the precached copy is a hit).
  // The literal below is the pre-currentScript fallback: that directory,
  // root-absolute, with the placeholder nginx strips on localhost.
  var bundleSrc = "/v/__GHD_VERSION__/i18n/bundles." + lang + ".js";
  try {
    if (document.currentScript && document.currentScript.src) {
      bundleSrc = new URL("../i18n/bundles." + lang + ".js", document.currentScript.src).href;
    }
  } catch (e) {}
  var el = document.createElement("script");
  el.src = bundleSrc;
  window.__GHD_BUNDLE_READY__ = new Promise(function (resolve) {
    el.onload = function () {
      resolve(true);
    };
    // A bundle that cannot be fetched must not hold the app: the runtime
    // boots on the keys and says so on the console.
    el.onerror = function () {
      resolve(false);
    };
  });
  document.head.appendChild(el);
})();
